import * as S from './styles';
export function DataError({ title }: { title: string }) {
  return (
    <S.Content>
      {/*
      <img src="/img/noData1.svg" alt="no data" />
      */}
      <p>Erro ao buscar {title}</p>
    </S.Content>
  );
}
